module.exports = {
    resources: {
        'supervisor': {
            name: 'Supervisor'
        },
        admin: {
          name: 'Admin'
        },
        operator: {
            name: 'Operator'
        },
        'setup': {
            name: 'Setup'
        },
        'about': {
            name: 'About',
        }
    }
}
